import { Injectable } from '@angular/core';
import { AjaxService } from './ajax.service';
import { AddressFromZipCodeInterface } from '../interfaces/address-from-zip-code.interface';
import { AddressFromZipCodeResultInterface } from '../interfaces/address-from-zip-code-result.interface';
import { AddressTypeInterface } from '../interfaces/adress-type.interface';
import { PossibleAddressInterface } from '../interfaces/possible-address.interface';
import { PossibleAddressResultInterface } from '../interfaces/possible-address-result.interface';
import { PossibleLocationInterface } from '../interfaces/possible-location.interface';
import { StateInterface } from '../interfaces/state.interface';
import { ENDPOINTS } from '../constants/endpoints.constant';

@Injectable()
export class AddressService {
  constructor(private ajaxService: AjaxService) {}

  public async getAddressTypes(): Promise<string[]> {
    const response = await this.ajaxService.get<AddressTypeInterface[]>(ENDPOINTS.addressTypes.url);

    const addressTypes = response.map((item) => item.tipo);

    return addressTypes;
  }

  public async getAddressFromZipCode(zipCode: string): Promise<AddressFromZipCodeInterface> {
    const response = await this.ajaxService.get<AddressFromZipCodeResultInterface>(
      `${ENDPOINTS.addressFromZipCode.url}/${zipCode}`
    );

    return {
      tipoLogradouro: response && response.tipoLogradouro,
      logradouro: response && response.logradouro,
      bairro: response && response.bairro,
      estado: response && response.uf,
      municipio: response && response.municipio
    };
  }

  public async getStatesList(): Promise<string[]> {
    const response = await this.ajaxService.get<StateInterface[]>(ENDPOINTS.statesList.url);

    const statesList = response.map((item) => item.sigla);

    return statesList;
  }

  public async getPossibleLocations(state: string, location: string): Promise<string[]> {
    const response = await this.ajaxService.post<PossibleLocationInterface[]>(ENDPOINTS.possibleLocations.url, {
      uf: state,
      trecho: location
    });

    const possibleLocations = response.map((item) => item.nomeOficial).filter((item) => item);

    return possibleLocations;
  }

  public async getPossibleAdresses(
    state: string,
    location: string,
    address: string,
    number: string
  ): Promise<PossibleAddressInterface[]> {
    const response = await this.ajaxService.post<PossibleAddressResultInterface[]>(ENDPOINTS.possibleAdresses.url, {
      uf: state,
      localidade: location,
      logradouro: address,
      numero: number
    });

    if (response && response[0] && response[0].message) {
      return [];
    }

    const possibleAdresses = response.map((item) => {
      return {
        cep: item.cep,
        bairro: item.bairro,
        logradouro: item.logradouro
      };
    });

    return possibleAdresses;
  }
}
